import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFavoriteClips, getFavoritePodcasts, getFavoriteStations } from 'store/reducers/favorites';
import { setContent } from 'actions/content-actions';
import CONTENT_TYPE_ID from 'globalConst/contentTypes-const';

interface WithFavouriteHOCProps {
  contentTypeId: string;
  slug: string;
  store?: boolean;
}

export function withFavorite<P>(InnerComponent: React.FC<P>) {
  return (props: P): JSX.Element => {
    const { contentTypeId, slug, store = false } = props as unknown as WithFavouriteHOCProps;

    const stations = useSelector(getFavoriteStations);
    const podcasts = useSelector(getFavoritePodcasts);
    const clips = useSelector(getFavoriteClips);
    const dispatch = useDispatch();

    let componentItems: Array<never>;

    switch (contentTypeId) {
      case CONTENT_TYPE_ID.FAVORITE_STATION_COLLECTION:
        componentItems = stations;
        break;
      case CONTENT_TYPE_ID.FAVORITE_PODCAST_COLLECTION:
        componentItems = podcasts;
        break;
      case CONTENT_TYPE_ID.FAVORITE_CLIP_COLLECTION:
        componentItems = clips;
        break;
      default:
        return null;
    }
    useEffect(() => {
      if (store) {
        const collection = {};
        collection[slug] = { ...props, items: componentItems };
        dispatch(setContent(collection, contentTypeId));
      }
    }, [componentItems]);

    return <InnerComponent {...props} items={componentItems} />;
  };
}

export default withFavorite;
